import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import GrayPanel from '../../components/GrayPanel';
import { capitalizeFirstLetter } from '../../lib/utils';

import {PanelStyle} from '../../constants';

/**
 * Rodzaj zamierzenia inwestycyjnego Kontener
 */
class IntendedBuildType extends React.Component {
  render() {
    let {
      leftCol,
      labelCol,
      inputCol,
      inputStyle,
      errorSpanStyle,
      rightCol,
      labelStyle,
      rowStyle,
    } = PanelStyle;

    labelCol = 'col-sm-3';
    inputCol = 'col-sm-5';
    

    const formDict = {
      Name: {
        label: 'Nazwa zamierzenia budowlanego',
      },
      Type: {
        label: 'Rodzaj zamierzenia budowlanego',
      },
    };

    return (
      <GrayPanel title={ this.props.title }>
        <p>tj. rodzaj planowanych robót budowlanych (np. budowa/wykonanie a także odbudowa, rozbudowa, nadbudowa, obiektu budowlanego/, lub prace polegające na przebudowie , montażu, remoncie lub rozbiórce obiektu budowlanego oraz zmiana sposobu użytkowania obiektu budowlanego lub jego części) oraz funkcja i sposób zagospodarowania terenu inwestycji (np. budynek: mieszkalny, jednorodzinny, wielorodzinny, usługowy, handlowy, gospodarczy, garaż): </p>
        {Object.keys(formDict).map((v, i) => {
          return (
            <div className="row mobile-row" key={i} style={rowStyle}>
              <div className={leftCol} />
              <div className={labelCol}>
                <label style={labelStyle}>{formDict[v].label}</label>
              </div>
              <div className={inputCol}>
               {Object.keys(this.props).indexOf('onChange' + capitalizeFirstLetter(v)) > -1 ? 
                <input
                  style={{...inputStyle, borderColor: Object.keys(this.props.errors).indexOf(v) > -1 ? 'red' : '#ccc' }}
                  className="form-control"
                  value={this.props.data[v] ? this.props.data[v] : ''}
                  onChange={() => this.props['onChange' + capitalizeFirstLetter(v)]() }
                /> : 
                <input
                  style={{...inputStyle, borderColor: Object.keys(this.props.errors).indexOf(v) > -1 ? 'red' : '#ccc' }}
                  className="form-control"
                  value={this.props.data[v] ? this.props.data[v] : ''}
                  disabled
                />
              }
              </div>
              <div className={rightCol} />
            </div>
          );
        })}
      </GrayPanel>
    )
  }
}


export default IntendedBuildType;


// WEBPACK FOOTER //
// src/containers/IntendedBuildType/index.jsx